import {
  replyToReview,
  updateReviewReply,
  deleteReviewReply,
} from "@/api/providerDashboard";

export default {
  startEditReply(item) {
    this.replyTarget = item._id;
    this.replyContent = item.reply.content;
    this.isEditing = true;
  },
  async submitReply(reviewId) {
    if (!this.replyContent.trim())
      return this.$alert("답글 내용을 입력해주세요.");
    if (this.replyContent.length > this.replyMaxLength)
      return this.$alert(
        `답글은 ${this.replyMaxLength}자 이내로 입력해주세요.`
      );
    try {
      if (this.isEditing) {
        await updateReviewReply(reviewId, { content: this.replyContent });
      } else {
        await replyToReview(reviewId, { content: this.replyContent });
      }
      this.$message.success("답글이 저장되었습니다.");
      this.replyTarget = null;
      this.replyContent = "";
      this.isEditing = false;
      this.loadReviews();
    } catch (err) {
      this.$alert("답글 저장 실패");
    }
  },
  async handleDeleteReply(reviewId) {
    try {
      await this.$confirm("답글을 삭제하시겠습니까?", {
        confirmButtonText: "삭제",
        cancelButtonText: "취소",
      });
      await deleteReviewReply(reviewId);
      this.$message.success("답글이 삭제되었습니다.");
      this.loadReviews();
    } catch (e) {
      /* cancelled */
    }
  },
};
